<script>
    export let profile;
    export let color = "orangered";
</script>

<div class={["marker", profile.id].join(" ")}>
    {#if profile.id === "ev"}
        <svg
            class="front"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
        >
            <path d="M7.5 15L0 0L15 0Z" fill="white" />
        </svg>
        <svg class="back" width="15" height="8" viewBox="0 0 15 8" fill="none">
            <path d="M7.5 0L0 8L15 8Z" fill="black" />
        </svg>
    {:else if profile.id === "moto"}
        <svg width="15" height="23" viewBox="0 0 15 23" fill="none">
            <path d="M2 0L13 0L7.5 23Z" fill={color} />
        </svg>
    {:else}
        <div class="front" />
        <div class="top" />
        <div class="back" />
    {/if}
</div>

<style>
    .marker {
        position: relative;
        width: 15px;
        height: 23px;
    }

    .vehicle div {
        width: 100%;
    }

    .front {
        opacity: 0.15;
        mix-blend-mode: screen;
        background: white;
        height: 45%;
    }

    .top {
        background: inherit;
        height: 27.5%;
    }

    .back {
        opacity: 0.15;
        background: black;
        height: 27.5%;
    }

    .suv .front {
        height: 40%;
    }

    .suv .top {
        height: 0;
    }

    .suv .back {
        opacity: 0.15;
        height: 60%;
    }

    .van .front {
        height: 25%;
    }

    .van .top {
        height: 65%;
    }

    .van .back {
        opacity: 0.15;
        height: 10%;
    }

    .ev .front {
        background: transparent;
        height: 15px;
    }

    .ev .top {
        height: 0;
    }

    .ev .back {
        transform: translateY(-12px);
        opacity: 0.15;
        background: transparent;
        height: 8px;
    }

    .moto {
        background: transparent !important;
    }
</style>
